import React from 'react';
import { ArrowRight, Factory, Cpu, Leaf, Wrench, Droplets, Mountain, HeartPulse, Plane } from 'lucide-react';
import { industries } from '../../data/mock';

const industryIcons = [Factory, Leaf, Cpu, Wrench, Droplets, Mountain, HeartPulse, Plane];

const IndustriesSection = () => {
  return (
    <section id="industries" className="relative bg-black py-24 lg:py-32 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-[0.02]">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(74, 144, 164, 0.5) 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }} />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-[#4A90A4] text-sm font-semibold uppercase tracking-wider mb-4 block">Industries</span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Industries We <span className="text-[#4A90A4]">Support</span>
          </h2>
          <p className="text-white/60 text-lg">
            Innovation happens in every industry. We help businesses across all sectors identify and claim their eligible funding.
          </p>
        </div>

        {/* Industries Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {industries.map((industry, index) => {
            const IconComponent = industryIcons[index] || Factory;
            return (
              <div
                key={index}
                className="group relative bg-white/[0.02] border border-white/10 p-6 hover:border-[#4A90A4]/50 hover:bg-[#4A90A4]/5 transition-all duration-500 overflow-hidden"
              >
                {/* Hover Background */}
                <div className="absolute inset-0 bg-gradient-to-br from-[#4A90A4]/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                
                <div className="relative z-10">
                  <div className="w-12 h-12 bg-[#4A90A4]/10 flex items-center justify-center mb-4 group-hover:bg-[#4A90A4] transition-colors duration-300">
                    <IconComponent size={24} className="text-[#4A90A4] group-hover:text-white transition-colors duration-300" />
                  </div>
                  <h3 className="text-lg font-semibold text-white mb-2 group-hover:text-[#4A90A4] transition-colors duration-300">
                    {industry.name}
                  </h3>
                  <p className="text-white/50 text-sm leading-relaxed">
                    {industry.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA Banner */}
        <div className="mt-16 relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-[#4A90A4]/20 to-[#4A90A4]/5" />
          <div className="relative z-10 border border-[#4A90A4]/30 p-8 lg:p-12">
            <div className="flex flex-col lg:flex-row justify-between items-center gap-8">
              <div>
                <h3 className="text-2xl font-bold text-white mb-3">
                  Don't see your industry?
                </h3>
                <p className="text-white/60">
                  If you're solving problems and improving processes, you likely qualify. Let's talk.
                </p>
              </div>
              <a
                href="#contact"
                className="group bg-[#4A90A4] text-white px-8 py-4 font-medium flex items-center gap-3 hover:bg-[#5BA0B4] transition-all duration-300 whitespace-nowrap hover:shadow-lg hover:shadow-[#4A90A4]/25"
              >
                Book a Free Review
                <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform duration-300" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;
